
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-tax-invoice-retail-grid',
  templateUrl: './tax-invoice-retail-grid.component.html',
  styleUrls: ['./tax-invoice-retail-grid.component.css']
})
export class TaxInvoiceRetailGridComponent implements OnInit {

  title="Tax Invoice Retail";
  dtOptions: any = {};
  empList :any =[];
  mode :any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;


  constructor(public service : UserService) { }

  ngOnInit(): void {
    this.empList = this.service.empList;
    //
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component.ts